// Library
import React from 'react'

// Assets
import WhiteLogo from 'assets/images/white-logo.png'
import GlobeLogo from 'assets/images/paytrack-logo.png'
import PaymentLogo from 'assets/images/proof-of-payment.png'

// Ui
import Row from 'ui/Row'
import Col from 'ui/Col'
import Heading from 'ui/Heading'
import Text from 'ui/Text'

// Paths
import { PATH_LOGIN } from 'routes/paths'
import Box from 'ui/Box'
import Link from 'ui/Link'

export default function PageRegisterExisted() {
  return (
    <Row className="m-0 vh-100" style={{ backgroundColor: '#1351aa' }}>
      <Col
        xs={{ span: 10, offset: 1, vcenter: true }}
        sm={{ span: 11, offset: 1, vcenter: true }}
        md={{ span: 10, offset: 2, vcenter: true }}
        lg={{ span: 6, offset: 2, vcenter: true }}
      >
        <Row>
          <Col xs={12}>
            <img className="d-block mw-100" src={WhiteLogo} alt="globeLogo" width={"128"} />
            <img className="mw-100" src={GlobeLogo} alt="paytrackLogo" />
          </Col>
          <Col xs={12}>
            <Heading color="#ffffff" paddingTop={45} paddingBottom={10}>
              Hi Ka - Globe!
            </Heading>
            <Text color="#ffffff" paddingBottom={10}>
              You have already registered to your Paytrack account.
            </Text>
            <Text color="#ffffff" paddingBottom={45}>
              To login, click the link below:
            </Text>
            <Box
              round={false}
              backgroundColor="#074296"
              style={{ padding: '15px 20px', marginBottom: 45 }}
            >
              <Link path={PATH_LOGIN}>
                <Text color="#fff">
                  {window.location.origin + process.env.PUBLIC_URL + PATH_LOGIN}
                </Text>
              </Link>
            </Box>
          </Col>
          <Col xs={8} sm={4}>
            <img className="mw-100" src={PaymentLogo} alt="paymentLogo" />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
